<div class="margin-b-1 margin-t-1">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="8px">
        <div fxFlex>
            <div class="bold text-center" *ngIf="label">{{label|translate}}</div>
            <div class="box" fxLayout="column">
                <mat-form-field>
                    <input type="text" matInput placeholder="{{ 'search' | translate }}" [(ngModel)]="allItemsSearch"
                        (keyup)="onSearch(true)" />
                </mat-form-field>
                <div *ngFor="let item of allItems">
                    <div class="item padding-1 clickable" [class.inactive]="item[activeFieldName] === false"
                        (click)="selectItem(item)" *ngIf="item.show">
                        <div>
                            {{item.shuttleLabel}}
                            {{ item[activeFieldName] === false ? '(' + ('inactive' | translate) + ')' : '' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px">
            <i class="fas clickable action-btn mat-elevation-z1 primary-background-color padding-1"
                [class.fa-angle-double-left]="direction==='rtl'" [class.fa-angle-double-right]="direction==='ltr'"
                (click)="selectAll()"></i>
            <i class="fas clickable action-btn mat-elevation-z1 primary-background-color padding-1"
                [class.fa-angle-double-right]="direction==='rtl'" [class.fa-angle-double-left]="direction==='ltr'"
                (click)="removeAll()"></i>
        </div>
        <div fxFlex>
            <div class="bold text-center">{{'selected'|translate}}</div>
            <div class="box" fxLayout="column">
                <mat-form-field>
                    <input type="text" matInput placeholder="{{ 'search' | translate }}"
                        [(ngModel)]="selectedItemsSearch" (keyup)="onSearch(false)" />
                </mat-form-field>
                <div *ngFor="let selectedItem of selectedItems;let i=index">
                    <div class="item padding-1" fxLayout="row" fxLayoutAlign="start center" *ngIf="selectedItem.show">
                        <div fxFlex [class.inactive]="selectedItem[activeFieldName] === false">
                            {{selectedItem.shuttleLabel}}
                            {{ selectedItem[activeFieldName] === false ? '(' + ('inactive' | translate) + ')' : '' }}
                        </div>
                        <i class="fas fa-times-circle clickable error-color" (click)="removeItem(i, selectedItem)"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>